const recentViewdProduct = document.querySelector(".recently_viewed_proudct");
const recentViewedProductHandle = recentViewdProduct.dataset.productHandle;
var LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY = "shopify-recent-view";
var LOCAL_STORAGE_DELIMITER = ",";
var BUTTON_ACTIVE_CLASS = "active";

var selectors = {
  grid: "[grid-recentViewProduct]",
};

document.addEventListener("DOMContentLoaded", function () {
  var productHandle = recentViewedProductHandle || false;
  if (!productHandle)
    return console.error(
      "[recentViewPorduct] Missing `data-product-handle` attribute. Failed to update the recentViewPorduct."
    );
  updaterecentViewPorduct(productHandle);

  var Recentgrid = document.querySelector(selectors.grid) || false;
  if (Recentgrid) {
    recentViewsetupGrid(Recentgrid);
  }
});

/* DreamPrices (2026-08-11): "?view=recent-view-card" ska bara ge tillbaka ETT
   litet produktkort (`.product-grid-item`). Om Shopify av någon anledning
   (t.ex. en produkt med en annan mall-suffix som saknar en egen
   recent-view-card-vy) faller tillbaka på HELA produktsidan i stället, låg
   tidigare hela sidan – inklusive en andra <cart-notification>-varukorgslåda
   med samma id som originalet – och injicerades rakt in i slidern. Det gjorde
   att varukorgslådan hamnade fel positionerad (t.ex. långt ner på sidan) och
   verkade "stänga sig själv" eller visa en grå ruta utan innehåll.

   Fixen: plocka ALLTID ut bara `.product-grid-item`-kortet ur svaret innan
   det sätts in i sladen. Om inget kort hittas (trasigt svar) hoppar vi bara
   över den produkten i stället för att injicera hela sidan. */
var extractProductCardHTML = function (html) {
  if (typeof html !== "string" || !html) return "";
  try {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var card = doc.querySelector(".product-grid-item");
    return card ? card.outerHTML : "";
  } catch (e) {
    return "";
  }
};

var recentViewsetupGrid = function (Recentgrid) {
  var recentViewPorduct = getrecentViewPorduct();
  if (recentViewPorduct.length > 1) {
    recentViewdProduct.classList.remove("no-js-inline");
  }

  var requestsRecentViewed = recentViewPorduct
    .slice(0)
    .reverse()
    .map(function (handle) {
      if (recentViewedProductHandle !== handle) {
        var productTileTemplateUrl = "/products/" + handle + "?view=recent-view-card";
        return fetch(productTileTemplateUrl)
          .then(function (res) {
            if (res.status == 200) {
              return res.text();
            }
          })
          .then(function (html) {
            return extractProductCardHTML(html);
          })
          .catch(function () {
            return "";
          });
      }
    });

  Promise.all(requestsRecentViewed).then(function (responses) {
    var recentViewPorductProductCards = responses.join("");
    Recentgrid.innerHTML = recentViewPorductProductCards;
  });
};

var getrecentViewPorduct = function () {
  var recentViewPorduct =
    localStorage.getItem(LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY) || false;
  if (recentViewPorduct)
    return recentViewPorduct.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setrecentViewPorduct = function (array) {
  var recentViewPorduct = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length)
    localStorage.setItem(
      LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY,
      recentViewPorduct
    );
  return recentViewPorduct;
};

var updaterecentViewPorduct = function (handle) {
  var recentViewPorduct = getrecentViewPorduct();
  var indexInrecentViewPorduct = recentViewPorduct.indexOf(handle);
  if (indexInrecentViewPorduct === -1) {
    recentViewPorduct.push(handle);
  } else {
    let currentViewdProduct = recentViewPorduct.splice(
      indexInrecentViewPorduct,
      1
    );
    recentViewPorduct.push(currentViewdProduct);
  }
  return setrecentViewPorduct(recentViewPorduct);
};

var recentViewPorductContains = function (handle) {
  var recentViewPorduct = getrecentViewPorduct();
  return recentViewPorduct.indexOf(handle) !== -1;
};

var resetrecentViewPorduct = function () {
  return setrecentViewPorduct([]);
};
